import { render, staticRenderFns } from "./OpencartLink.vue?vue&type=template&id=2d66d3a8&"
import script from "./OpencartLink.vue?vue&type=script&lang=js&"
export * from "./OpencartLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports